import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import { OAuthSuccessPage } from '~/components/OAuthCallback';

export const Route = createFileRoute('/auth/success' as any)({
  component: function Body() {
    return <OAuthSuccessPage />;
  },
});
